import I18n from 'I18n';
// @ts-expect-error not migrated.
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import PatagoniaSidebarHeader from 'ContentEditorUI/components/sidebar/PatagoniaSidebarHeader';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncTreeViewModuleListContainer = makeAsyncComponent(() => import(
// @ts-expect-error not migrated.
/* webpackChunkName: 'TreeViewModuleListContainer' */
'ContentEditorUI/components/sidebar/list/treeView/TreeViewModuleListContainer'));
const PatagoniaSidebarContentContainer = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    blockSize: "100%",
    minBlockSize: "0",
    children: [/*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      flexGrow: 0,
      children: /*#__PURE__*/_jsx(PatagoniaSidebarHeader, {
        headerText: I18n.text('patagonia.sidebar.contentsHeader')
      })
    }), /*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      minBlockSize: "0",
      children: /*#__PURE__*/_jsx(AsyncTreeViewModuleListContainer, {
        blockSize: "100%",
        overflowY: "scroll"
      })
    })]
  });
};
export default PatagoniaSidebarContentContainer;